import React, { Fragment } from 'react';
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom'
import { useMappedState } from 'redux-react-hook';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import './App.css';
import Login from './components/Login/Login';
import Messages from './components/Messages/MessagesComponent';
import Invoices from './components/Invoices/Invoices';
import ContactComponent from './components/Contact/ContactComponent';
import BankComponent from './components/Bank/BankComponent';
import RodoComponent from './components/Rodo/RodoComponent';
import LogoutComponent from './components/Logout/LogoutComponent';
import AppBarComponent from './components/AppBar/AppBarComponent';
import { getLoginToken } from './helpers/sessionHandler';

const mapState = state => ({
  authentication: state.authentication,
});

const App = () => {
  const { authentication } = useMappedState(mapState);
  const authenticated = authentication || getLoginToken();

  return (
    <MuiThemeProvider>
      <Router>
        <div className="App">
          <AppBarComponent/>
          <div className="App-intro">
              <div className="container">
                <Route exact path="/" component={Login} />
                <Route path="/logout" component={LogoutComponent} />
                {authenticated && <Fragment>
                  <Route path="/messages" component={Messages} />
                  <Route path="/invoices" component={Invoices} />
                  <Route path="/contact" component={ContactComponent} />
                  <Route path="/bank" component={BankComponent} />
                  <Route path="/rodo" component={RodoComponent} />
                </Fragment>}
              </div>
          </div>
        </div>
      </Router>
    </MuiThemeProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js